import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { getUserFromCookies } from '../utils/Cookie-utils';
import {
  getAccessToken,
  isIdleTimeoutExceeded,
  logoutToLogin,
} from '../utils/session-utils';
import NotFoundPage from '../Pages/Authentication/NotFoundPage';


const ProtectedRoute = ({ element, allowedRoles }) => {
  const { authReady } = useAuth();
  const user = getUserFromCookies();
  const idleExpired = isIdleTimeoutExceeded();

  if (idleExpired) {
    logoutToLogin({
      message: 'You have been logged out due to 15 minutes of inactivity.',
    });
    return <Navigate to="/" replace />;
  }

  if (!authReady && getAccessToken()) {
    return null;
  }

  if (!getAccessToken() || !user?.data) {
    return <Navigate to="/" replace />;
  }

  if (user.data.loginForFirstTime === true) {
    return <Navigate to="/change-password-first-login" replace />;
  }

  const { role } = user.data;
  if (allowedRoles.includes(role)) {
    return element;
  }

  return <NotFoundPage />;
};

export default ProtectedRoute;
